export default __webpack_public_path__ + "static/media/scoping.51b29349.svg";